import axios from './axios.config';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
import { app } from './firebase';

export const loginWithGoogle = () => async (dispatch) => {

  const provider = new GoogleAuthProvider();

  const auth = getAuth(app);
  signInWithPopup(auth, provider)
    .then(async (result) => {
      const email = result.user.email;
      const name = result.user.displayName;
      const profileImage = result.user.photoURL || null;

      if (email) {
        const { data } = await axios.post(`/user/login/google`, { email, name, profileImage });

        const accessToken = data.token;
        localStorage.setItem('access_token', accessToken);

        dispatch({
          type: "LoginSuccess",
          payload: data.User,
        });

      }

    }).catch((error) => {
      dispatch({
        type: "LoginFailure",
        payload: error,
      });

    });
};


export const loginUser = (email, password) => async (dispatch) => {

  try {
    dispatch({
      type: "LoginRequest"
    });

    const { data } = await axios.post(`/user/login`, { email, password });

    const accessToken = data.token;
    localStorage.setItem('access_token', accessToken);

    dispatch({
      type: "LoginSuccess",
      payload: data.User,
    });

  } catch (error) {
    dispatch({
      type: "LoginFailure",
      payload: error,
    });
  }
}

export const loadUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LoadUserRequest",
    });

    const storedAccessToken = localStorage.getItem('access_token');
    axios.defaults.headers.common['Authorization'] = `Bearer ${storedAccessToken}`;

    const { data } = await axios.get(`/user/profile/me`);

    dispatch({
      type: "LoadUserSuccess",
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: "LoadUserFailure",
      payload: error,
    });
  }
}


export const logoutUser = () => async (dispatch) => {

  try {

    dispatch({
      type: "LogoutRequest",
    });

    localStorage.removeItem('access_token');
    delete axios.defaults.headers.common['Authorization'];
    await axios.get(`/user/logout`);

    const auth = getAuth();

    if (auth) {
      signOut(auth);
    }

    dispatch({
      type: "LogoutSuccess",
    });

    return true;

  } catch (error) {

    dispatch({
      type: "LogoutFailure",
      payload: error,
    });

    throw error;
  }

}


export const getUserProfile = (userId) => async (dispatch) => {
  try {
    dispatch({
      type: "LoadUserProfileRequest"
    });

    const { data } = await axios.get(`/user/${userId}`);

    dispatch({
      type: "LoadUserProfileSuccess",
      payload: data.userInfo,
    });
  } catch (error) {

    dispatch({
      type: "LoadUserProfileFailure",
      payload: error,
    });

  }
}

export const updateUserProfile = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "UpdateProfileRequest" });

    // 1. Send data to backend
    const { data } = await axios.put(`/user/profile/update`, formData);

    dispatch({
      type: "UpdateProfileSuccess",
      payload: data.message
    });

    // 2. IMPORTANT: Refresh the user data in Redux so the UI updates
    const { data: userData } = await axios.get(`/user/profile/me`);
    dispatch({
      type: "LoadUserSuccess",
      payload: userData,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: "UpdateProfileFailure",
      payload: error.response?.data?.message || "Update Failed",
    });
    throw error;
  }
};


export const sendMessage = (formData) => async (dispatch) => {
  try {
    const { data } = await axios.post(`/support/query`, formData);

    return data;
  } catch (error) {
    throw error;
  }
};



export const VerifyWithGoogle = async (InputEmail) => {
  try {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();

    const result = await signInWithPopup(auth, provider);
    const email = result.user.email;

    if (InputEmail !== email) {
      return {
        success: false,
        message: "Email Id doesn't match ,Please Check your Email before Verification",
      }
    }
    if (email) {
      const { data } = await axios.put(`/user/verify/google`, { email });
      return data; // Successfully returns the data
    }

    throw new Error('No email found');
  } catch (error) {
    const errorCode = error.code;
    const credential = GoogleAuthProvider.credentialFromError(error);

    // Return or throw the error depending on your needs
    return {
      success: false,
      message: "Something Went Wrong , please try again",
      code: errorCode,
      credential,
    };
  }
};